import Repeater_ResponsiveComponent from '../components/Repeater/viewer/skinComps/Responsive/Responsive.skin';
import Repeater_ResponsiveController from '../components/Repeater/viewer/Repeater.controller';


const Repeater_Responsive = {
  component: Repeater_ResponsiveComponent,
  controller: Repeater_ResponsiveController
};


export const components = {
  ['Repeater_Responsive']: Repeater_Responsive
};

